import { CategoriaEnum } from '@acme/auth'
import dayjs from 'dayjs'

interface Contexto {
    categoria?: number
    dtFimAtivacao?: string | Date | null
    pathname: string
}

/**
 * Diz se o usuário com plano inativo deve ser levado ao Meu plano: só quem
 * contrata (cliente e avaliação) sem ativação vigente, e nunca de dentro das
 * telas de plano — lá ele já está resolvendo, inclusive no meio do checkout.
 */
export function isRedirecionarParaMeuPlano({
    categoria,
    dtFimAtivacao,
    pathname,
}: Contexto) {
    if (pathname.startsWith('/planos')) return false
    if (
        categoria !== CategoriaEnum.Cliente &&
        categoria !== CategoriaEnum.Avaliacao
    )
        return false
    return !dtFimAtivacao || dayjs(dtFimAtivacao).isBefore(dayjs())
}
